










import { Component, Prop, Vue } from "vue-property-decorator";
import { Const } from "@/const";

import * as def from "@/definitions";
import { ImageHelper } from '@/helper/imageHelper';
import { StringHelper } from '@/helper/stringHelper';
import { FileHelper } from '@/helper/fileHelper';
import { ExcelHelper } from '@/helper/excelHelper';
import { DebugHelper } from "@/helper/debugHelper";

import * as Encoding from 'encoding-japanese';

import SelectExcelSheetModal from "@/commonComponents/alertModal/selectExcelSheetModal/selectExcelSheetModal.vue";

@Component({
  components: {
      SelectExcelSheetModal
  }
})
export default class FileOpen extends Vue {
    // ファイルタイプ
    // image / document
    @Prop() private fileType!: string;
    @Prop({ default: false }) private useWhiteTransparent! : string | boolean;

    // 読み込みタイプ保持用
    private readType = "";

    // ファイル名保持用
    private fileName = "";

    private isUseWhiteTransparent()
    {
        return this.useWhiteTransparent == "true" || this.useWhiteTransparent == true;
    }

    // 入力リセットのための変数
    private uploadReady : boolean = true;

    // 画像の一時作成用
    private tempImage;
    private mimeType : string = "";

    public get accept() : string
    {
        var str = "";
        this.readType = "";
        if (this.fileType == "image")
        {
            str = "image/jpeg,image/png,image/gif,image/bmp,image/svg+xml";
        }
        else if(this.fileType == "document")
        {
            str = ".project" + "," + Const.PROJECT_FILE_EXTENSION + "," + Const.INSERTION_FILE_EXTENSION + "," + ".lcx,.lcxt";
        }
        else if(this.fileType == "label9")
        {
            str = ".lcx,.lcxt";
        }
        else if(this.fileType == "text")
        {
            str = ".txt";
        }
        else if(this.fileType == "excel")
        {
            str = ".csv,.xlsx";
        }
        return str;
    }

    // ファイルオープンダイアログを開く
    public open() : void
    {
        var input = this.$refs.input as HTMLElement;
        input.click();
    }

    // イベントを送る
    public sendImageSelected(imageBase64 : string, width : number, height : number, mimeType : string, image64WhiteTransparent : string = "") : void
    {
        this.$emit("imageSelected", imageBase64, width, height, mimeType, image64WhiteTransparent);
    }

    public sendTextSelected(text : string) : void
    {
        this.$emit("textSelected", text, this.fileType, this.readType, this.fileName);
    }

    // イベントハンドラー
    public onFileChange(e) : void
    {
        var files : FileList = e.target.files || e.dataTransfer.files;

        if (files.length <= 0)
        {
            // ファイルの選択をキャンセルした
            return;
        }
        var file : File = files[0];

        // mimeTypeの保持
        this.mimeType = file.type;

        // ファイル名の保持
        this.fileName = file.name;

        // ファイルリーダーを作成
        var reader : FileReader = new FileReader();
        reader.onload = this.onLoadFile;
        if (this.fileType == "image")
        {
            // 画像読み込み
            this.readType = "image";
            reader.readAsDataURL(file);
        }
        else if(this.fileType == "document")
        {
            // ファイル形式で読み込み方式を変更する
            var filename = file.name;
            var ext = FileHelper.getFileExtension(filename);
            DebugHelper.trace(ext)
            if(ext == "lcx" || ext == "lcxt")
            {
                // 旧ラベル屋形式
                // バイナリとして読み込む
                this.readType = "binary";
                reader.readAsArrayBuffer(file);
            }
            else
            {
                // 新形式
                // テキストとして読み込む
                this.readType = "text";
                reader.readAsText(file);
            }
        }
        else if(this.fileType == "label9")
        {
            // バイナリとして読み込む
            this.readType = "binary";
            reader.readAsArrayBuffer(file);
        }
        else if(this.fileType == "text")
        {
            // テキスト読み込み
            this.readType = "text";
            reader.readAsText(file);
        }
        else if(this.fileType == "excel")
        {
            // ファイル形式で読み込み方式を変更する
            var filename = file.name;
            var ext = FileHelper.getFileExtension(filename);
            DebugHelper.trace(ext);
            if(ext.toLowerCase() == "xlsx")
            {
                // Excel標準形式
                // バイナリとして読み込む
                this.readType = "binary";
                reader.readAsArrayBuffer(file);
            }
            else
            {
                // csv形式
                // テキストバイナリとして読み込む
                this.readType = "textBinary";
                reader.readAsArrayBuffer(file);
            }
        }
        
        // 選択ファイルをクリアする
        this.reset();

        this.$emit("importFile", reader.result);
    }

    private onLoadFile(e) : void
    {
        var result = e.target.result;
        if (result == null) { return; }

        if (this.readType == "image")
        {
            var imageBase64 : string = result as string;
            // Imageの読み込みを行い画像ファイルを調べる
            this.tempImage = new Image();
            this.tempImage.onload = this.onLoadImage;
            this.tempImage.src = imageBase64;
        }
        else if(this.readType == "text")
        {
            var text : string = result as string;
            this.sendTextSelected(text);
        }
        else if((this.readType == "binary" && this.fileType == "document") || this.fileType == "label9")
        {
            var arrayBuffer : ArrayBuffer = result as ArrayBuffer;
            var buffer = new Uint8Array(arrayBuffer);
            // zip解凍
            var Unzip = require('zlibjs/bin/unzip.min').Zlib.Unzip;
            var uz = new Unzip(buffer);
            var filenames = uz.getFilenames();
            if(filenames && filenames.length > 0)
            {
                // 最初のファイル(xml)
                var text = "";
                try
                {
                    var decompressed = uz.decompress(filenames[0]);
                    text = StringHelper.utf8ArrayToStr(decompressed);
                }
                catch(e)
                {
                    DebugHelper.trace(e);
                }

                this.sendTextSelected(text);
            } 
        }
        else if(this.readType == "textBinary")
        {
            // 文字列に変換
            var unicodeText = ExcelHelper.csvBinaryToString(result);
            this.sendTextSelected(unicodeText);
        }
        else if(this.readType == "binary" && this.fileType == "excel")
        {
            var arrayBuffer : ArrayBuffer = result as ArrayBuffer;
            
            // エクセル読み込み
            ExcelHelper.xlsxBinaryToJsonStringWithSelectSheet(arrayBuffer, (sheetNames : string[], callback : (index : number) => void) =>
            {
                var modal = this.$refs.selectExcelSheetModal as SelectExcelSheetModal;
                modal.open(sheetNames, (button : string, index : number) =>
                {
                    if(button == "ok")
                    {
                        callback(index);
                    }
                });
            }, (result) =>
            {
                this.sendTextSelected(result);
            }, () =>
            {
                DebugHelper.trace("import excel error");
            });
        }
    }

    private onLoadImage()
    {
        // svgの場合はラスタライズが必要かどうか調べる
        var isRasterize = this.mimeType == "image/svg+xml" && ImageHelper.isSVGRasterizeNeeded(this.tempImage.src);

        if(isRasterize)
        {
            DebugHelper.trace("SVG is rasterized.");

            // ラスタライズでSVGは劣化するのでサイズを4倍にしておく
            var imageWidth = this.tempImage.naturalWidth * 4;
            var imageHeight = this.tempImage.naturalHeight * 4;

            // ラスタライズ処理を入れる
            ImageHelper.convertSVGImageToPng(this.tempImage.src, imageWidth, imageHeight, 0, (png) =>
            {
                DebugHelper.trace("SVG is rasterized completely.");

                if(this.isUseWhiteTransparent)
                {
                    // 白色透明化を使う
                    ImageHelper.createWhiteTransparentImage(png, (image) =>
                    {
                        this.sendImageSelected(png, imageWidth, imageHeight, "image/png", image);
                        // 一時情報の削除
                        this.clearTemp();
                    });
                }
                else
                {
                    // 白色透明化を使わない
                    this.sendImageSelected(png, imageWidth, imageHeight, "image/png");
                    // 一時情報の削除
                    this.clearTemp();
                }
            });
        }
        else
        {
            if(this.isUseWhiteTransparent)
            {
                // 白色透明化を使う
                ImageHelper.createWhiteTransparentImage(this.tempImage.src, (image) =>
                {
                    this.sendImageSelected(this.tempImage.src, this.tempImage.naturalWidth, this.tempImage.naturalHeight, this.mimeType, image);
                    // 一時情報の削除
                    this.clearTemp();
                });
            }
            else
            {
                // 白色透明化を使わない
                this.sendImageSelected(this.tempImage.src, this.tempImage.naturalWidth, this.tempImage.naturalHeight, this.mimeType);
                // 一時情報の削除
                this.clearTemp();
            }
        }
    }

    private reset()
    {
        this.uploadReady = false;
        this.$nextTick(() =>
        {
            this.uploadReady = true;
        });
    }

    private clearTemp()
    {
        this.tempImage = null;
        this.mimeType = "";
    }

}
